<template>
  <div class="history">
      <nav class="top-nav flex">
          <span
              v-for="(item, index) in navs"
              :key="index"
              :class="curNav == index ? 'cur' : ''"
              @click="navInfo(index)"
              >{{ item }}</span
          >
      </nav>
      <div class="table-scroll mod" v-show="curNav == 0">
          <div class="table-l fl">
              <table width="100%" cellspacing="0" cellpadding="0">
                  <tr>
                      <th>日期</th>
                  </tr>
                  <tr v-for="(item, index) in dataInfoBx" :key="index">
                      <td>{{ item.riqi }}</td>
                  </tr>
              </table>
          </div>
          <div class="table-r">
              <div class="table-r-wrap">
                  <table width="100%" cellspacing="0" cellpadding="0">
                      <tr>
                          <th>净买额（沪股通）</th>
                          <th>净买额（深股通）</th>
                          <th>合计</th>
                      </tr>
                      <tr v-for="(item, index) in dataInfoBx" :key="index">
                          <td :class="item.jiage_s | formateRedGreen">
                              {{ item.jiage_s }}亿
                          </td>
                          <td :class="item.jiage_h | formateRedGreen">
                              {{ item.jiage_h }}亿
                          </td>
                          <td :class="item.jiage_hj | formateRedGreen">
                              {{ item.jiage_hj }}亿
                          </td>
                      </tr>
                  </table>
              </div>
          </div>
          <!-- <p class="load-btn">
              <span
                  class="load-btn-more"
                  style="width: 45%"
                  @click="getPagesInfo()"
                  >查看更多</span
              >
              <span
                  class="load-btn-foldUp"
                  @click="getLssjBx()"
                  style="width: 45%"
                  >全部收起</span
              >
          </p> -->
      </div>
      <div class="table-scroll mod" v-show="curNav == 1">
          <div class="table-l fl">
              <table width="100%" cellspacing="0" cellpadding="0">
                  <tr>
                      <th>日期</th>
                  </tr>
                  <tr v-for="(item, index) in dataInfoNx" :key="index">
                      <td>{{ item.riqi }}</td>
                  </tr>
              </table>
          </div>
          <div class="table-r">
              <div class="table-r-wrap">
                  <table width="100%" cellspacing="0" cellpadding="0">
                      <tr>
                          <th>港股通(沪)</th>
                          <th>港股通(深)</th>
                          <th>合计</th>
                      </tr>
                      <tr v-for="(item, index) in dataInfoNx" :key="index">
                          <td :class="item.jiage_s | formateRedGreen">
                              {{ item.jiage_s }}亿
                          </td>
                          <td :class="item.jiage_h | formateRedGreen">
                              {{ item.jiage_h }}亿
                          </td>
                          <td :class="item.jiage_hj | formateRedGreen">
                              {{ item.jiage_hj }}亿
                          </td>
                      </tr>
                  </table>
              </div>
          </div>
          <!-- <p class="load-btn">
              <span
                  class="load-btn-more"
                  style="width: 45%"
                  @click="getPagesInfoNx()"
                  >查看更多</span
              >
              <span
                  class="load-btn-foldUp"
                  @click="getLssjNx()"
                  style="width: 45%"
                  >全部收起</span
              >
          </p> -->
      </div>
  </div>
</template>

<script>
// 获取历史北向数据
import { bxzjLsmx } from "@/api/lszx.js";

export default {
  name: "HistoryNorthList",
  data() {
      return {
          curNav: 0,
          navs: ["历史北向数据", "历史南向数据"],
          historyNorthData: [
              {
                  id: 0,
                  date: "2022-01-06",
                  hgt: "-22.17",
                  ggt: "+16.38",
                  total: "-125.30",
              },
              {
                  id: 1,
                  date: "2022-01-06",
                  hgt: "-22.17",
                  ggt: "+16.38",
                  total: "-125.30",
              },
              {
                  id: 2,
                  date: "2022-01-06",
                  hgt: "-22.17",
                  ggt: "+16.38",
                  total: "-125.30",
              },
          ],
          dataInfoBx: [],
          dataInfoNx: [],
          pages: 2,
          size: 10,

          pagesNx: 2,
          sizeNx: 10,
      };
  },
  filters: {
      formateTag: function (v) {
          if (v == undefined || v == null) return;
          if (v > 0) return "交易中";
          if (v < 0) return "已结束";
      },
      formatePrefixData: function (v) {
          if (v == undefined || v == null) return "--";
          if (v > 0) return "+" + v;
          if (v < 0) return v;
      },
      formateRedGreen: function (v) {
          if (v == undefined || v == null) return;
          if (v > 0) return "ft-red";
          if (v < 0) return "ft-green";
      },
  },
  mounted: function () {
      this.getLssjBx();
      window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
      navInfo: function (index) {
          this.curNav = index;
          if (index == 0) {
              this.getLssjBx();
          } else {
              this.getLssjNx();
          }
      },

      // 请求历史数据(北向)
      getLssjBx: function () {
          var _this = this;
          _this.pages = 2;
          var params = {
              type: "1",
              page: 1,
              size: 20,
          };
          bxzjLsmx(params).then((res) => {
              if (res.data.err == 0) {
                  _this.dataInfoBx = Object.values(res.data.data.list);
              } else {
                  _this.dataInfoBx = [];
              }
          });
      },

      // 下一页北向
      getPagesInfo: function () {
          this.pages = this.pages + 1;
          var _this = this;
          var params = {
              type: "1",
              page: this.pages,
              size: this.size,
          };

          bxzjLsmx(params).then((res) => {
              if (res.data.err == 0) {
                  console.log( _this.dataInfoBx);
                  console.log(res.data.data.list);
                      _this.dataInfoBx = _this.dataInfoBx.concat(
                          Object.values(res.data.data.list)
                      );

              } else {
                  _this.dataInfoBx = [];
              }
          });

          console.log(_this.dataInfoBx);
      },

      // 请求历史数据南向
      getLssjNx: function () {
          var _this = this;
          _this.pagesNx = 2;
          var params = {
              type: "2",
              page: 1,
              size: 20,
          };
          bxzjLsmx(params).then((res) => {
              if (res.data.err == 0) {
                  _this.dataInfoNx =Object.values(res.data.data.list);
              } else {
                  _this.dataInfoNx = [];
              }
          });
      },

      // 下一页南向
      getPagesInfoNx: function () {
          this.pagesNx = this.pagesNx + 1;
          var _this = this;
          var params = {
              type: "2",
              page: this.pagesNx,
              size: this.sizeNx,
          };
          bxzjLsmx(params).then((res) => {
              if (res.data.err == 0) {
                  _this.dataInfoNx = _this.dataInfoNx.concat(
                     Object.values(res.data.data.list)
                  );
              } else {
                  _this.dataInfoNx = [];
              }
          });
      },

      handleScroll() {
          //这里使用个延时加载，不然滑动屏幕的时候会不断触发方法，去计算高度，浪费性能
          let that = this;
          clearTimeout(this.timer);
          that.timer = setTimeout(function () {
              var scrollTop =
                  document.documentElement.scrollTop ||
                  document.body.scrollTop;
              let windowHeight =
                  document.documentElement.clientHeight ||
                  document.body.clientHeight;
              let scrollHeight =
                  document.documentElement.scrollHeight ||
                  document.body.scrollHeight;
              //获取到关键属性的值后，判断即可
              if (scrollTop + windowHeight+35 >= scrollHeight) {
                  console.log("触底");

                  var curNav = that.curNav;

                  that.$nextTick(function(){
                      if (curNav === 0) {
                          that.getPagesInfo();
                      } else {
                          that.getPagesInfoNx();
                      }
                  })

              }
          }, 500);
      },
  },
};
</script>
